import {useAuth} from '@apps-common/auth-react';
import HelpMenuComponent from '@apps-common/ui-components/NavBar/HelpMenu.jsx';
import {MenuItem} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {connect, useDispatch} from 'react-redux';
import {notify} from '@actions/notifications';

import {startTour} from '@app/actions/tour';
import {trackEvent} from '@app/analytics';
import {useGetCollectionsCount} from '@app/api/collections';
import {TOURS} from '@app/constants/tour';
import useCollectionParams from '@app/hooks/useCollectionParams';
import useOrgParams from '@app/hooks/useOrgParams';
import {isUsersOrg} from '@app/util/user';

const HelpMenu = ({startTour, ...props}) => {
  const auth = useAuth();
  const {orgId} = useOrgParams();
  const {data: totalCollections} = useGetCollectionsCount(orgId);
  const {resetCollection} = useCollectionParams();
  const dispatch = useDispatch();
  const NO_ORG_ACCESS_ERR_KEY = 'no-org-access';
  const user = auth.user;
  const isUserOrg = isUsersOrg(user?.claims, orgId);

  const onTourStart = () => {
    if (!isUserOrg) {
      dispatch(
        notify({
          message: 'Switch back to your organization to start the tour.',
          severity: 'warning',
          persist: true,
          key: NO_ORG_ACCESS_ERR_KEY,
        })
      );
    } else if (totalCollections === 0) {
      startTour(TOURS.EMPTY_STATE);
    } else {
      resetCollection();
      setTimeout(() => {
        startTour(TOURS.COLLECTION_TOUR_PT1);
      }, 300);
    }

    trackEvent('Tour', {
      action: 'Started',
    });
  };

  return (
    <HelpMenuComponent {...props}>
      <MenuItem onClick={onTourStart} data-testid="take-tour">
        Take a tour!
      </MenuItem>
    </HelpMenuComponent>
  );
};

HelpMenu.propTypes = {
  startTour: PropTypes.func,
};

const mapDispatchProps = {
  startTour,
};

export default connect(null, mapDispatchProps)(HelpMenu);
